import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CheckoutService } from '@checkout-v2/feature';
import { CustomOrder } from '@order/const';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { UrlModule } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-buttons',
  templateUrl: './order-confirmation-info-buttons.component.html',
  styleUrls: ['./order-confirmation-info-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AsyncPipe, UrlModule, RouterLink, SdvorButtonComponent],
})
export class OrderConfirmationInfoButtonsComponent implements OnInit {
  order$: Observable<CustomOrder>;

  constructor(private checkoutService: CheckoutService) {}

  ngOnInit(): void {
    this.order$ = this.checkoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
